import React, { useRef } from 'react';
import BlendSlider from './BlendSlider';
import strings from './strings';
import { PlayIcon, PauseIcon, StopIcon, ChevronUpIcon } from './icons';

const SWIPE_UP_PX = 24;

/**
 * The PRACTICE strip: the one row that stays on screen while a song plays.
 * Stop, play/pause and the labelled blend slider. The tab on its top edge
 * expands the dock (tempo, show, zoom); a swipe up anywhere except the
 * slider does the same.
 */
const MobileStrip = ({ transport, blend, blendPending, expanded, onExpand, beat }) => {
  const touchStartY = useRef(null);

  const onTouchStart = (e) => {
    if (e.target.closest('.mps-blend')) return;
    touchStartY.current = e.touches[0].clientY;
  };
  const onTouchEnd = (e) => {
    if (touchStartY.current === null) return;
    const delta = touchStartY.current - e.changedTouches[0].clientY;
    touchStartY.current = null;
    if (delta > SWIPE_UP_PX && !expanded) onExpand();
  };

  return (
    <div className="mps-strip" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      {!expanded && (
        <button
          type="button"
          className={`mps-drawer-tab ${beat ? `beat ${beat}` : ''}`}
          onClick={onExpand}
          aria-expanded={false}
          aria-label={strings.moreControls}
        >
          <ChevronUpIcon size={22} />
        </button>
      )}

      <button
        type="button"
        className="mps-round mps-stop"
        onClick={transport.onStop}
        disabled={!transport.canStop}
        aria-label={strings.stop}
      >
        <StopIcon size={18} />
      </button>

      <button
        type="button"
        className="mps-round mps-play"
        onClick={transport.isPlaying ? transport.onPause : transport.onPlay}
        disabled={transport.isPlaying ? !transport.canPause : !transport.canPlay}
        aria-label={transport.isPlaying ? strings.pause : strings.play}
      >
        {transport.isPlaying ? <PauseIcon size={24} /> : <PlayIcon size={24} />}
      </button>

      <div className={`mps-strip-blend ${blend.dimmed ? 'mps-dimmed' : ''}`} title={blend.dimmed ? strings.partsOverrideOn : undefined}>
        <BlendSlider
          compact
          value={blend.value}
          onChange={blend.onChange}
          disabled={blend.disabled}
          pending={blendPending}
          onDisabledTap={blend.onPickPart}
        />
      </div>
    </div>
  );
};

export default MobileStrip;
